export const insultReplacements: Record<string, string> = {
  idiot: "friend",
  idiots: "friends",
  idiotic: "misguided",
  stupid: "misguided",
  stupidity: "poor judgment",
  moron: "friend",
  morons: "friends",
  moronic: "poorly thought out",
  dumb: "uninformed",
  dumbass: "friend",
  imbecile: "friend",
  fool: "friend",
  foolish: "unwise",
  fools: "friends",
  retard: "friend",
  retards: "friends",
  retarded: "misguided",
  incompetent: "inexperienced",
  incompetence: "lack of experience",
  lazy: "less engaged",
  useless: "not helpful",
  worthless: "not valuable",
  pathetic: "disappointing",
  loser: "friend",
  losers: "friends",
  jerk: "friend",
  jerks: "friends",
  clown: "friend",
  clowns: "friends",
  joke: "not serious",
  ridiculous: "surprising",
  absurd: "unexpected",
  insane: "surprising",
  crazy: "unexpected",
  nuts: "unusual",
  lame: "underwhelming",
  terrible: "not great",
  awful: "not ideal",
  horrible: "concerning",
  worst: "least effective",
  trash: "low quality",
  garbage: "low quality",
};
